/*
 * @Description: user mutations type
 */

export enum UserMutationTypes {
  SET_TOKEN = 'SET_TOKEN',
  SET_USER_INFO = 'SET_USER_INFO',
}
